import React from "react";
import TopNav from "../../components/Navigation/TopNav";
import Products from "../../components/Products/Products";
import PageTitle from "@alliancesafetycouncil/asc-page-title";
import { getFeature } from "../../lib/util";
import { useSelector } from 'react-redux'

const BrowseAPIs = ({ enabled = true }) => {
  const products = useSelector(state => state.productRedcuer.data)
  
  if (!enabled) {
    return null
  }

  return (
    <div className="relative">
      <div className="fixed w-full z-20">
        <TopNav />
      </div>
      <div className="spacer-for-nav h-17"></div>
      <div className="p-2 md:p-4 h-full">
        <div className="mb-4">
          <PageTitle>
            <i className="fa-light fa-code text-orange-500 mr-2"></i>
            API Products
          </PageTitle>
        </div>
        <Products enabled={getFeature("Products")} data={products} />
      </div>
    </div>
  );
};

export default BrowseAPIs;
